import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const download = http.post(
  createMockEndpoint('/terminal/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
